import { render, staticRenderFns } from "./organisation.vue?vue&type=template&id=5dcfe09e&"
import script from "./organisation.vue?vue&type=script&lang=ts&"
export * from "./organisation.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* custom blocks */
import block0 from "./organisation.vue?vue&type=custom&index=0&blockType=route"
if (typeof block0 === 'function') block0(component)

export default component.exports